import ScrollPage, {SectionItem} from "../../Components/ScrollPage/ScrollPage";
import Section from "../../Components/Section/Section";
import WankelStory from "../WenkleStory/WankleStory";
import ArazonaContent from "./ArazonaContent";

interface ScrollTo {
  index: number;
}

export const Sections: SectionItem[] = [
  { label: "Arazona",        id: "wankel" }
];


const Arazona: React.FC<ScrollTo> = ({ index }) => (
  <ScrollPage index={index} sections={Sections}>
    <Section section={Sections[0].id}>
      <ArazonaContent />
    </Section>
  </ScrollPage>
);

export default Arazona;